module.exports = __webpack_public_path__ + "static/media/fitchipotle.9e5df2c2.jpg";